import api from './api';

const BASE = '/print-settings';

export default {
  get: () =>
    api
      .get(BASE, {
        params: { functionCode: 'PRINT_SETTINGS_VIEW' },
      })
      .then((r) => r.data),

  update: (data) =>
    api
      .put(BASE, {
        ...data,
        functionCode: 'PRINT_SETTINGS_UPDATE',
      })
      .then((r) => r.data),
};